import { EventEmitter, Inject, Injectable } from '@angular/core';
import { loadModules } from 'esri-loader';
import { environment } from 'projects/app/src/environments/environment';
import { BehaviorSubject } from 'rxjs';
import { LayerListId } from '../components/map/layer-list/layer-list.model';
import { LAYER } from '../constants/layer.constant';
import { LibModuleOptions, MOL_LIB_TOKEN } from '../lib.config';
import { AppConfigService, ConfigApp } from './appconfig.service';
import { HanhChinhService } from './hanh-chinh.service';
import { LayerListService } from './layer-list.service';
import { SliderOpacityService } from './slider-opacity.service';
import { ThongTinQuyHoachService } from './thong-tin-quy-hoach.service';
@Injectable({
  providedIn: 'root'
})
export class MapService {
  private loadedSource = new BehaviorSubject<boolean>(false);
  notify = new EventEmitter<{ message?: string, type?: string }>();
  get loaded$() {
    return this.loadedSource.asObservable();
  }
  view: __esri.MapView;
  private gmapRoad: __esri.WebTileLayer;
  private gmapHybrid: __esri.WebTileLayer;
  private basemap: __esri.TileLayer;
  private bienDongHybrid: __esri.TileLayer;
  private bienDongOSM: __esri.TileLayer;

  config: ConfigApp;

  constructor(
    private layerListService: LayerListService,
    private hanhChinhService: HanhChinhService,
    private thongTinQuyHoachService: ThongTinQuyHoachService,
    private opacityService: SliderOpacityService,
    private configService: AppConfigService,
    @Inject(MOL_LIB_TOKEN) private option:LibModuleOptions,
  ) {

  }

  async loadConfig() {
    this.config = await this.configService.getApp().toPromise();
  }

  private subribeLayerSelected = (value: { selected: LayerListId[]; newSelected?: LayerListId; type?: 'add' | 'remove'; }) => {
    if (this.view) {
      let message = '';
        if (value.newSelected === LayerListId.NenDuongPho) {
        this.gmapRoad.visible = this.bienDongOSM.visible = value.type === 'add';
        value.type === 'add' && (message = 'Đã chuyển bản đồ nền sang kiểu đường phố');
      } else if (value.newSelected === LayerListId.NenVeTinh) {
        this.gmapHybrid.visible = this.bienDongHybrid.visible = value.type === 'add';
        value.type === 'add' && (message = 'Đã chuyển bản đồ nền sang kiểu vệ tinh');
      }
      if (message) {
        this.notify.next({ message, type: 'info' });
      }
    }
  }

  async loadMap(params: { element: HTMLDivElement, mapProperties?: __esri.MapProperties, viewProperties?: __esri.MapViewProperties }) {
    if (!this.config) {
      await this.loadConfig();
    }
    const { element, mapProperties, viewProperties } = params;
    type MapModule = [
      typeof import('esri/Map'),
      typeof import('esri/views/MapView'),
      typeof import('esri/layers/TileLayer'),
      typeof import('esri/layers/WebTileLayer'),
      typeof import('esri/widgets/ScaleBar'),
      typeof import('esri/layers/MapImageLayer'),
      typeof import('esri/widgets/Home'),
      typeof import('esri/geometry/Point'),
      typeof import('esri/layers/OpenStreetMapLayer'),
      typeof import('esri/layers/support/LOD'),
    ];
    const [Map,
      MapView,
      TileLayer,
      WebTileLayer,
      ScaleBar,
      MapImageLayer,
      Home,
      Point,
      OpenStreetMapLayer,LOD] = await(loadModules([
        'esri/Map',
        'esri/views/MapView',
        'esri/layers/TileLayer',
        'esri/layers/WebTileLayer',
        'esri/widgets/ScaleBar',
        'esri/layers/MapImageLayer',
        'esri/widgets/Home',
        'esri/geometry/Point',
        'esri/layers/OpenStreetMapLayer',
        'esri/layers/support/LOD'
      ]) as Promise<MapModule>);
    const map = new Map({
      ...mapProperties,
      basemap: 'hybrid'
    });
    this.view = new MapView({
      map,
      container: element,
      ...viewProperties,
      center: [107.181614, 10.508349],
      scale: 500000
    });

    this.view.ui.add(new ScaleBar({ view: this.view, unit: 'dual' }), 'bottom-left');
    this.loadedSource.next(true);
    this.view.ui.move('zoom', 'bottom-right');
    this.view.ui.add(new Home({
      view: this.view, label: 'Xem toàn khu vực',
      viewpoint: {
        targetGeometry: new Point({
          longitude:107.181614 ,
          latitude: 10.508349,
          spatialReference: this.view.spatialReference
        }),
        scale: this.option.map.scale
      }
    }), 'bottom-right');
    if (localStorage.getItem('EXTENT')) {
      this.view.extent = JSON.parse(localStorage.getItem('EXTENT'));
    }
    this.gmapRoad = new OpenStreetMapLayer({ id: 'road' });
    // {
    //   urlTemplate: 'https://mt1.google.com/vt/lyrs=m&x={col}&y={row}&z={level}',
    //   id: 'road'
    // });
    this.gmapHybrid = new WebTileLayer(
      {
        urlTemplate: 'https://mt1.google.com/vt/lyrs=y&x={col}&y={row}&z={level}',
        id: 'hybrid',
        visible: false
      });

      const thuaDatLayer = new WebTileLayer({
        urlTemplate:`${this.thongTinQuyHoachService.URL}/thuadat/tile/{level}/{row}/{col}`,
        id:'thuadat',
        tileInfo:{
          "dpi": 96,
          "format": "png",
          "origin": {
          "x": -20037700,
          "y": 30241100
          },
          "spatialReference": {
          "wkid": 102100,
          },
          "lods": [
          {
          "level": 0,
          "resolution": 16.933367200067735,
          "scale": 64000
          },
          {
          "level": 1,
          "resolution": 8.466683600033868,
          "scale": 32000
          },
          {
          "level": 2,
          "resolution": 4.233341800016934,
          "scale": 16000
          },
          {
          "level": 3,
          "resolution": 2.116670900008467,
          "scale": 8000
          },
          {
          "level": 4,
          "resolution": 1.0583354500042335,
          "scale": 4000
          },
          {
          "level": 5,
          "resolution": 0.5291677250021167,
          "scale": 2000
          },
          {
          "level": 6,
          "resolution": 0.26458386250105836,
          "scale": 1000
          },
          {
          "level": 7,
          "resolution": 0.13229193125052918,
          "scale": 500
          },
          {
          "level": 8,
          "resolution": 0.06614596562526459,
          "scale": 250
          },
          {
          "level": 9,
          "resolution": 0.033072982812632296,
          "scale": 125
          }
          ]
          }
      })
      const getTileUrl =  thuaDatLayer.getTileUrl;
      let that = this;
      thuaDatLayer.getTileUrl =  function(){
        const tileUrl =  getTileUrl.apply(this,arguments) as string
        const view = that.view.center;
        return tileUrl + `?lng=${view.x}&lat=${view.y}`
      }
    this.bienDongOSM = new TileLayer({
      url: this.option.map.bienDong.osm,
      visible: true
    });
    this.bienDongHybrid = new TileLayer({
      url: this.option.map.bienDong.hybrid,
      visible: false
    });
    map.basemap = null;

    map.addMany([this.gmapRoad, this.gmapHybrid, this.bienDongOSM, this.bienDongHybrid]);

    const layers = this.config.map.layers;
    if (layers.thongTinQuyHoach) {
      this.basemap = new TileLayer(layers.thongTinQuyHoach);
      map.add(this.basemap);
    }

    map.add(thuaDatLayer)

    this.layerListService.add(LayerListId.NenDuongPho);
    this.layerListService.add(LayerListId.QuyHoachSDD);
    this.layerListService.add(LayerListId.ThuaDat);



    this.hanhChinhService.view = this.thongTinQuyHoachService.view = this.view;

    this.view.watch('stationary', async value => {
      localStorage.setItem('EXTENT', JSON.stringify(this.view.extent));
    });


    this.view.when(() => this.loadedSource.complete());
    this.layerListService.layerSelected.subscribe(this.subribeLayerSelected);

    this.opacityService.changed.subscribe(opacity => {
      this.basemap.opacity =  opacity / 100;
    });
    this.opacityService.opacity = 80;
  }

}
